import React from "react";
import { Leaf, ExternalLink } from "lucide-react";
import ProductPlaceholder from "@/components/ProductPlaceholder";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function resolveProductUrl(url, memberId) {
  if (!url) return "#";
  if (url.startsWith("/r/")) {
    return `${BACKEND_URL}/api${url}${memberId ? `?m=${encodeURIComponent(memberId)}` : ""}`;
  }
  return url;
}

export const MicrobiomeApothecary = ({ products, basedOn, memberId }) => {
  if (!products || products.length === 0) return null;
  return (
    <section className="mt-10" data-testid="microbiome-apothecary">
      <p className="label-eyebrow mb-2 flex items-center gap-2">
        <Leaf className="w-3.5 h-3.5 text-[#C05C42]" /> Gut-supportive apothecary
      </p>
      <p className="text-sm text-[#5C6359] mb-4 max-w-2xl">
        Plant medicines and foundations matched to your terrain
        {basedOn && basedOn.length > 0 ? ` — ${basedOn.join(", ")}` : ""}.
      </p>
      <div className="space-y-3">
        {products.map((p) => (
          <a
            key={p.id}
            href={resolveProductUrl(p.url, memberId)}
            target="_blank"
            rel="noreferrer"
            data-testid={`microbiome-product-${p.id}`}
            className="flex items-start gap-4 bg-[#F1ECE4] border border-[#D1C7B8] rounded-2xl p-4 hover:-translate-y-0.5 transition-transform group"
          >
            <div className="w-16 h-16 rounded-xl overflow-hidden bg-[#D1C7B8] shrink-0">
              {p.image ? (
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" onError={(e) => { e.target.style.display = "none"; }} />
              ) : (
                <ProductPlaceholder name={p.name} category={p.category} tags={p.tags} productId={p.id} />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs uppercase tracking-widest text-[#C05C42]">{p.category}</p>
              <p className="font-serif text-lg text-[#2D322B] mt-1 leading-snug flex items-center gap-2">
                {p.name}
                <ExternalLink className="w-3.5 h-3.5 text-[#5C6359] group-hover:text-[#C05C42]" />
              </p>
              <p className="text-sm text-[#5C6359] mt-1 leading-relaxed">{p.summary}</p>
              {p.why && <p className="text-xs text-[#C05C42] mt-2 italic">{p.why}</p>}
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};
